import FormInput from '@/views/components/Inputs/FormInput';
import HiddenFormInput from '@/views/components/Inputs/HiddenFormInput';
import { Col, Row } from 'antd';
import type { FC } from 'react';

const ClaimsSettingsCarrierSettingsForm: FC = () => {
  return (
    <Row gutter={15}>
      <Col md={6}>
        <FormInput
          editMode
          name={['carrierSettings', 'carrierClaimManagerName']}
          label="Claim Manager Name"
          margin="mb-10"
        />
        <FormInput
          editMode
          name={['carrierSettings', 'carrierReleaseAmount']}
          label="Release Amount"
          margin="m-0"
          inputType="number"
        />
      </Col>
      <Col md={6}>
        <FormInput
          editMode
          name={['carrierSettings', 'carrierThresholdAmount']}
          label="Threshold Amount"
          margin="mb-10"
          inputType="number"
        />
        <FormInput
          editMode
          name={['carrierSettings', 'carrierMaxLiability']}
          label="Maximum Liability Amount"
          margin="m-0"
          inputType="number"
        />
      </Col>
      <Col md={6}>
        <FormInput
          editMode
          name={['carrierSettings', 'carrierDeductibleAmount']}
          label="Deductible Amount"
          margin="mb-10"
          inputType="number"
        />
        <FormInput
          editMode
          name={['carrierSettings', 'carrierClaimLimit']}
          label="Claim Limit"
          margin="m-0"
          inputType="number"
        />
      </Col>
      <Col md={6}>
        <FormInput
          editMode
          name={['carrierSettings', 'carrierSuitLimit']}
          label="Suit Limit"
          margin="mb-10"
          inputType="number"
        />
        <FormInput
          editMode
          name={['carrierSettings', 'gracePeriod']}
          label="Grace Period (in Days)"
          margin="m-0"
          inputType="number"
        />
      </Col>
      <HiddenFormInput name={['carrierSettings', 'carrierKey']} />
      <HiddenFormInput name={['carrierSettings', 'carrierName']} />
      <HiddenFormInput name={['carrierSettings', 'carrierScacCode']} />
    </Row>
  );
};

export default ClaimsSettingsCarrierSettingsForm;
